package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SubscribeToPlanRequest(
    @SerialName("planId") var planId: String? = null,
    @SerialName("customerId") var customerId: String? = null
)